export enum QuizEstiloDeVidaCategoriaEnum {
  ALIMENTACAO = 1,
  ATIVIDADE_FISICA = 2,
  COMPORTAMENTO_POSITIVO = 3,
  RELACIONAMENTOS = 4,
  CONTROLE_DE_ESTRESSE = 5,
}

const descricao = new Map<QuizEstiloDeVidaCategoriaEnum, string>([
  [QuizEstiloDeVidaCategoriaEnum.ALIMENTACAO, 'Alimentação'],
  [QuizEstiloDeVidaCategoriaEnum.ATIVIDADE_FISICA, 'Atividade Física'],
  [QuizEstiloDeVidaCategoriaEnum.COMPORTAMENTO_POSITIVO, 'Comportamento Positivo'],
  [QuizEstiloDeVidaCategoriaEnum.RELACIONAMENTOS, 'Relacionamentos'],
  [QuizEstiloDeVidaCategoriaEnum.CONTROLE_DE_ESTRESSE, 'Controle de Estresse'],
]);

export class QuizEstiloDeVidaCategoriaEnumDescription {
  static getDescricao(valor: QuizEstiloDeVidaCategoriaEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): { valor: QuizEstiloDeVidaCategoriaEnum; descricao: string }[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }
}
